import React, { useMemo } from 'react';
import { useLiveData } from 'hooks';
import { ALL_COLORING_GRID_CATEGORIES_QUERY } from 'app-constants/coloring-grid-categories';

import { Splash } from '../../../../shared/Components';
import { Box } from '../../../../shared/Typhography';

import { ColoringGridCollectionTable } from './Shared';

const ColoringGridCollectionsScreen = () => {
  const { docs: collections, state } = useLiveData(ALL_COLORING_GRID_CATEGORIES_QUERY);

  const data = useMemo(() => {
    return collections.map((item: any) => {
      const itemData = item.data();

      return {
        firebaseId: item.id,
        id: itemData.id,
        name: itemData.name,
        isAdminOnly: itemData.isAdminOnly,
        numberOfColoringGrids: itemData.numberOfColoringGrids,
      };
    });
  }, [collections]);

  if (state === 'loading') {
    return <Splash />;
  }

  return (
    <Box margin="150px auto">
      <h1>Coloring Grid Categories</h1>
      <ColoringGridCollectionTable data={data} />
    </Box>
  );
};

export default ColoringGridCollectionsScreen;
